import {disputeSmartSvg as Icon__small__disputeSmartSvg} from '../Icon__small/Icon__small--disputeSmart.js';

export var disputeSmart = {
  name: 'disputeSmart',
  category: 'icon',
  colorable: true,
  svg: Icon__small__disputeSmartSvg,
};
